import { useState, useEffect, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "moment/locale/pt-br";
import "./style.css";
import axios from "axios";

// Ícones ultra-avançados
const ARIcon = () => (<svg width="20" height="20" fill="currentColor"><circle cx="10" cy="10" r="9"/><text x="5" y="14" fontSize="8" fill="#fff">AR</text></svg>);
const ChallengeIcon = () => (<svg width="20" height="20" fill="currentColor"><rect x="2" y="2" width="16" height="16" rx="3"/><text x="4" y="14" fontSize="8" fill="#fff">🏆</text></svg>);
const LiveIcon = () => (<svg width="20" height="20" fill="red"><circle cx="10" cy="10" r="9"/><text x="3" y="14" fontSize="7" fill="#fff">LIVE</text></svg>);
const PrivacyIcon = () => (<svg width="20" height="20" fill="currentColor"><rect x="3" y="6" width="14" height="9" rx="2"/><circle cx="10" cy="10" r="2" fill="#fff"/></svg>);
const NotificationIcon = () => (<svg width="20" height="20" fill="currentColor"><path d="M10 18c.83 0 1.5-.67 1.5-1.5h-3c0 .83.67 1.5 1.5 1.5zm4.5-4.5V9c0-2.3-1.22-4.23-3.38-4.74V4c0-.62-.5-1.12-1.12-1.12-.62 0-1.12.5-1.12 1.12v.26C6.72 4.77 5.5 6.7 5.5 9v4.5L4.12 14.88c-.1.1-.22.25-.22.45V16h12.2v-.67c0-.2-.12-.35-.22-.45L14.5 13.5z"/></svg>);
const ModerationIcon = () => (<svg width="20" height="20" fill="orange"><rect x="2" y="2" width="16" height="16" rx="2"/><text x="3" y="14" fontSize="7" fill="#fff">MOD</text></svg>);
const APIIcon = () => (<svg width="20" height="20" fill="blue"><rect x="2" y="2" width="16" height="16" rx="2"/><text x="4" y="14" fontSize="7" fill="#fff">API</text></svg>);

export default function ShortsFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [shorts, setShorts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState({});
  const containerRef = useRef(null);
  const videoRefs = useRef({});

  // Handlers ultra-avançados
  const handleAR = (post) => alert("Aplicar efeitos AR neste Short");
  const handleChallenge = (post) => alert("Participar de desafio");
  const handleLiveStream = (post) => alert("Iniciar live");
  const handlePrivacy = (post) => alert("Configurar privacidade");
  const handleNotifications = (post) => alert("Gerenciar notificações");
  const handleModeration = (post) => alert("Ver moderação");
  const handleAPIIntegration = (post) => alert("Integrar com APIs externas");

  const fetchShorts = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/feed/shorts?limit=30`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setShorts(data.posts || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Shorts:", error);
      setLoading(false);
    }
  }, [user.token]);

  useEffect(() => {
    fetchShorts();
  }, [fetchShorts]);

  // Handle scroll snap
  const handleScroll = useCallback(() => {
    if (containerRef.current) {
      const scrollTop = containerRef.current.scrollTop;
      const height = window.innerHeight;
      const index = Math.round(scrollTop / height);

      if (index !== currentIndex && index >= 0 && index < shorts.length) {
        setCurrentIndex(index);
      }
    }
  }, [currentIndex, shorts.length]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  // Auto-play current video
  useEffect(() => {
    Object.entries(videoRefs.current).forEach(([index, video]) => {
      if (video) {
        if (parseInt(index) === currentIndex) {
          video.play().catch(() => {});
          setIsPlaying((prev) => ({ ...prev, [index]: true }));
        } else {
          video.pause();
          video.currentTime = 0;
          setIsPlaying((prev) => ({ ...prev, [index]: false }));
        }
      }
    });
  }, [currentIndex]);

  const togglePlay = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      if (video.paused) {
        video.play();
        setIsPlaying((prev) => ({ ...prev, [index]: true }));
      } else {
        video.pause();
        setIsPlaying((prev) => ({ ...prev, [index]: false }));
      }
    }
  };

  const handleLike = async (shortId) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/reactPost`,
        { postId: shortId, react: "like" },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setShorts((prev) =>
        prev.map((short) =>
          short._id === shortId
            ? { ...short, isLiked: !short.isLiked }
            : short
        )
      );
    } catch (error) {
      console.error("Error liking short:", error);
    }
  };

  const formatCount = (num) => {
    if (!num) return "0";
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num.toString();
  };

  if (loading) {
    return (
      <div className="shorts_feed_loading">
        <div className="shorts_loader"></div>
      </div>
    );
  }

  if (shorts.length === 0) {
    return (
      <div className="shorts_feed_empty">
        <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
          <path d="M10 9.35L15 12l-5 2.65V9.35zM12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/>
        </svg>
        <h3>Nenhum Short encontrado</h3>
        <p>Crie seu primeiro Short!</p>
      </div>
    );
  }

  return (
    <div className="shorts_feed" ref={containerRef}>
      {shorts.map((short, index) => (
        <div key={short._id} className="shorts_item">
          {/* Video */}
          <div className="shorts_video_wrapper" onClick={() => togglePlay(index)}>
            {short.videos?.[0] ? (
              <>
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  src={short.videos[0].url || short.videos[0]}
                  loop
                  muted
                  playsInline
                  className="shorts_video"
                />
                {!isPlaying[index] && (
                  <div className="shorts_play_overlay">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </div>
                )}
              </>
            ) : short.images?.[0] ? (
              <img
                src={short.images[0].url || short.images[0]}
                alt=""
                className="shorts_image"
              />
            ) : (
              <div className="shorts_placeholder">
                <svg viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
                  <path d="M10 9.35L15 12l-5 2.65V9.35z"/>
                </svg>
              </div>
            )}
          </div>

          {/* Side Actions */}
          <div className="shorts_actions">
            <button
              className={`shorts_action_btn ${short.isLiked ? "liked" : ""}`}
              onClick={() => handleLike(short._id)}
            >
              <div className="shorts_action_icon">
                <svg viewBox="0 0 24 24" fill={short.isLiked ? "#f00" : "none"} stroke="currentColor" strokeWidth="2" width="28" height="28">
                  <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
                </svg>
              </div>
              <span>{formatCount(short.reactions?.length || 0)}</span>
            </button>

            <button className="shorts_action_btn">
              <div className="shorts_action_icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28">
                  <path d="M10 15V9a3 3 0 0 1 3-3l4 9v11H5.72a2 2 0 0 1-2-1.7l-1.38-9a2 2 0 0 1 2-2.3zM17 2h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3" transform="rotate(180 12 12)"/>
                </svg>
              </div>
              <span>Não gostei</span>
            </button>

            <button className="shorts_action_btn">
              <div className="shorts_action_icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
              </div>
              <span>{formatCount(short.comments?.length || 0)}</span>
            </button>

            <button className="shorts_action_btn">
              <div className="shorts_action_icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28">
                  <circle cx="18" cy="5" r="3"/>
                  <circle cx="6" cy="12" r="3"/>
                  <circle cx="18" cy="19" r="3"/>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
                </svg>
              </div>
              <span>Partilhar</span>
            </button>

            {/* Botões Ultra-Avançados */}
            <button onClick={() => handleAR(short)} className="shorts_action_btn" title="AR">
              <ARIcon />
            </button>
            <button onClick={() => handleChallenge(short)} className="shorts_action_btn" title="Desafio">
              <ChallengeIcon />
            </button>
            <button onClick={() => handleLiveStream(short)} className="shorts_action_btn" title="Live">
              <LiveIcon />
            </button>
            <button onClick={() => handlePrivacy(short)} className="shorts_action_btn" title="Privacidade">
              <PrivacyIcon />
            </button>
            <button onClick={() => handleNotifications(short)} className="shorts_action_btn" title="Notificações">
              <NotificationIcon />
            </button>
            <button onClick={() => handleModeration(short)} className="shorts_action_btn" title="Moderação">
              <ModerationIcon />
            </button>
            <button onClick={() => handleAPIIntegration(short)} className="shorts_action_btn" title="API">
              <APIIcon />
            </button>

            <Link to={`/profile/${short.user.username}`} className="shorts_channel_avatar">
              <img src={short.user.picture} alt="" />
            </Link>
          </div>

          {/* Bottom Info */}
          <div className="shorts_info">
            <div className="shorts_channel">
              <Link to={`/profile/${short.user.username}`} className="shorts_channel_name">
                @{short.user.username}
              </Link>
              <button className="shorts_subscribe_btn">Subscrever</button>
            </div>

            <p className="shorts_title">
              {short.youtubeData?.title || short.text}
            </p>

            {short.youtubeData?.tags?.length > 0 && (
              <div className="shorts_tags">
                {short.youtubeData.tags.slice(0, 3).map((tag, i) => (
                  <span key={i}>#{tag}</span>
                ))}
              </div>
            )}

            <div className="shorts_music">
              <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
              </svg>
              <span>
                {short.tiktokData?.musicTitle || `${short.user.first_name} - Som original`}
              </span>
            </div>
          </div>

          {/* Shorts Logo */}
          <div className="shorts_logo_badge">
            <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M17.77 10.32c-.77-.32-1.2-.5-1.2-.5L18 9.06c1.84-.96 2.53-3.23 1.56-5.06s-3.24-2.53-5.07-1.56L6 6.94c-1.84.96-2.53 3.23-1.56 5.06.97 1.84 3.24 2.53 5.07 1.56l0 0 1.43-.75-1.35 6.6s-.13.48.34.93c.59.56 1.5.47 1.93.13.55-.42 2.52-3.4 2.52-3.4l-.24 2.29c0 .44.17.87.49 1.18.33.31.77.49 1.24.49h.05c1 0 1.79-.9 1.68-1.9l-.86-7.73c.01 0 1.88.97 1.03.92z"/>
            </svg>
            <span>Shorts</span>
          </div>
        </div>
      ))}
    </div>
  );
}
